import useUserContext from './useUserContext.js';
import { makeCurrentRole } from './UserProvider/helpers.js';

function useCurrentRole() {
  return makeCurrentRole(useUserContext());
}

export default useCurrentRole;
